/**
 * StoreHealthToaster — bridges the (non-React) storeHealth bus to the
 * ToastProvider so storage problems become visible to the operator.
 *
 * Mounted once, inside <ToastProvider> (see main.tsx). Renders nothing;
 * it just subscribes to `onStoreHealth` and `push()`es a toast for each
 * event. Subscription failures, localStorage quota overflows, and
 * corrupted-blob quarantines all surface here instead of failing
 * silently in the console.
 */

import { useEffect } from 'react';
import { useToast } from './ToastProvider';
import { onStoreHealth } from '../lib/db/storeHealth';

export function StoreHealthToaster() {
  const { push } = useToast();

  useEffect(() => {
    return onStoreHealth((evt) => {
      push({
        kind: evt.level,
        text: evt.message,
        detail: evt.detail,
        // Storage errors are sticky-ish: give the operator time to read.
        duration: evt.level === 'error' ? 8000 : 5000,
      });
    });
  }, [push]);

  return null;
}
